import QRadioGroup from './src/QRadioGroup';

QRadioGroup.install = Vue => {
  Vue.component(QRadioGroup.name, QRadioGroup);
};

export default QRadioGroup;
